import { makeStyles } from '@material-ui/core/styles';
import { redesignTheme } from '../../../theme';

const { colors, fonts, fontSize, spacing } = redesignTheme;

export const useMajorResultStyles = makeStyles(() => ({
  harmonyChart: {
    width: '100%',
    height: 560,
  },
  summaryCardBody: {
    margin: 0,
    fontFamily: fonts.opensans,
    fontSize: fontSize.base,
    color: colors.primaryDark,
    lineHeight: 'normal',
    '& p, & h3': {
      margin: 0,
    },
  },
  detailsSectionTitle: {
    margin: `0 0 ${spacing.lg}px`,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    color: colors.primaryDark,
    textAlign: 'center',
    lineHeight: 'normal',
  },
  scoreBadge: {
    position: 'absolute',
    bottom: spacing.sm,
    right: spacing.sm,
  },
  pyramidStack: {
    display: 'flex',
    flexDirection: 'column',
    gap: spacing.lg,
  },
  pyramidImage: {
    width: '100%',
    height: 'auto',
    display: 'block',
  },
  favoriteLabel: {
    margin: `${spacing.xs}px 0 0`,
    fontFamily: fonts.gothicSemiBold,
    fontSize: fontSize.lg,
    lineHeight: 'normal',
  },
}));
